import universityLogo from 'assets/branding/university.png'
import collegeLogo from 'assets/branding/college.png'

// Approved source PNGs are copied byte-for-byte from the institution's files.
export const INSTITUTION_BRANDING = {
  university: {
    label: 'Университет', name: 'Чуйский университет',
    subtitle: 'имени Султана Мамбеткалиева', level: 'Высшее образование',
    logo: universityLogo, logoAlt: 'Герб Чуйского университета',
  },
  college: {
    label: 'Колледж', name: 'Бишкекский колледж',
    subtitle: 'Чуйского университета', level: 'Среднее профессиональное образование',
    logo: collegeLogo, logoAlt: 'Герб Бишкекского колледжа',
  },
}

export function getInstitutionBranding(institution = 'university') {
  return INSTITUTION_BRANDING[institution === 'college' ? 'college' : 'university']
}

export function getInstitutionLogo(institution = 'university') {
  return getInstitutionBranding(institution).logo
}
